import { render } from "./SellsyAcademySlide.vue?vue&type=template&id=08ade620&scoped=true"
import script from "./SellsyAcademySlide.vue?vue&type=script&lang=js"
export * from "./SellsyAcademySlide.vue?vue&type=script&lang=js"

import "./SellsyAcademySlide.vue?vue&type=style&index=0&id=08ade620&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ade620"]])

export default __exports__